import { Navigate } from "react-router";

export function GfsOfferPestsPage() {
  return <Navigate to="../overview" replace />;
}
